const FRESH_LOGIN_KEY = 'freshLogin'

export function detectFreshLogin() {
  const fragmentParams = new URLSearchParams(window.location.hash.slice(1))
  const queryParams = new URLSearchParams(window.location.search)
  const hasParam = (name: string) =>
    fragmentParams.has(name) || queryParams.has(name)

  // An interactive OIDC callback reaches the top-level window with both
  // parameters. Silent SSO runs in an iframe, so it does not set this marker.
  if (hasParam('code') && hasParam('state')) {
    sessionStorage.setItem(FRESH_LOGIN_KEY, 'true')
  }
}

export function hasFreshLoginMarker() {
  return sessionStorage.getItem(FRESH_LOGIN_KEY) === 'true'
}

export function clearFreshLoginMarker() {
  sessionStorage.removeItem(FRESH_LOGIN_KEY)
}

export function consumeFreshLoginMarker() {
  const isFreshLogin = hasFreshLoginMarker()
  clearFreshLoginMarker()
  return isFreshLogin
}
